export default __webpack_public_path__ + "static/media/profile1.ee50d392.png";